export enum PlantHierarchyType {
  Global = 'Global',
  ManagementArea = 'ManagementArea',
  Region = 'Region',
  SubRegion = 'SubRegion',
  Country = 'Country',
  Cluster = 'Cluster',
  Plant = 'Plant'
}

export interface PlantHierarchyNode {
  type: PlantHierarchyType
  name: string
  hierarchyId: string
  code?: string
  children?: PlantHierarchyNode[]
}
